export const latest_studio = [
    { id: 1, image: require('../assets/latestprojects/Contractorgrowthpros.jpg'), title: 'Contractor', subTitle: 'Website Designing & Development', url: 'https://contractorgrowthpros.com/' },
    { id: 2, image: require('../assets/latestprojects/KeeraOrganics.jpg'), title: 'Keera Organics', subTitle: 'Website Designing & Development', url: 'https://keeraorganics.com/' },
    { id: 3, image: require('../assets/latestprojects/SangheraImmigration.jpg'), title: 'Sanghera Immigration', subTitle: 'Website Designing & Development', url: 'https://www.sangheraimmigration.com/' },
    { id: 4, image: require('../assets/latestprojects/ACHwriters.jpg'), title: 'ACH writers', subTitle: 'Website Designing & Development', url: 'https://achwriters.com/' },
    { id: 5, image: require('../assets/latestprojects/WildCardCasino.jpg'), title: 'Wild Card Casino', subTitle: 'Website Designing & Development', url: 'https://www.wildcardcasino.com/' }
]

export const web_data = [
    { id: 1, image: require('../assets/latestprojects/Fernandez.jpg'), title: 'Fernandez Grillhouse', subTitle: 'Website Designing & Development' },
    { id: 2, image: require('../assets/latestprojects/MamaSista.jpg'), title: 'Mama Sista', subTitle: 'Website Designing & Development' },
    { id: 3, image: require('../assets/latestprojects/Pandemic.jpg'), title: 'Pandemic Studio', subTitle: 'Website Designing & Development' },
    { id: 4, image: require('../assets/latestprojects/Costal.jpg'), title: 'Costal Wardrobe Solution', subTitle: 'Website Designing & Development' }
]

export const brand_data = [
    { id: 1, image: require('../assets/latestprojects/brand.jpg') },
    { id: 2, image: require('../assets/latestprojects/brand1.jpg') },
    { id: 3, image: require('../assets/latestprojects/brand2.jpg') }
]

export const digital_data = [
    { id: 1, image: require('../assets/latestprojects/Digital-Marketing.png') },
    { id: 2, image: require('../assets/latestprojects/Content-Writing.png') }
]

export const responsive = {
    lg_desktop: {
        breakpoint: { max: 3000, min: 1500 },
        items: 3,
        partialVisibilityGutter: 60
    },
    desktop: {
        breakpoint: { max: 1500, min: 1024 },
        items: 3,
        partialVisibilityGutter: 40
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
        partialVisibilityGutter: 30
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        partialVisibilityGutter: 20
    }
};

export const banner_responsive = {
    lg_desktop: {
        breakpoint: { max: 3000, min: 0 },
        items: 1
    }
}